var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CStickyBar',{attrs:{"position":_vm.position}},[_c('OCUncontainer',[_c('OContainer',{staticClass:"sticky-button-container"},[_c('FormButtons',{attrs:{"variant":"horizontal"}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }